//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const GroupedCalculationBulkInvoke: FeatureFlag = {"Id":"GroupedCalculationBulkInvoke","Label":"[10.24]Group compatible calculation bulk invokes","Impact":"When enabled, compatible frontend resolveCalculation bulk invokes are coalesced into grouped requests for supported datasource-backed calculations. When disabled, bulk invoke still sends the original per-request invokes.","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
